import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';

export type SectorDTO = {
	id: string;
	name: string;
	company_id: string;
};

async function getSectors(organizationId: string, companyId: string): Promise<SectorDTO[]> {
	const url = `/sector/${organizationId}/${companyId}`;
	const { data } = await Api.get<SectorDTO[]>(url);
	return data;
}

export function useGetSectors(organizationId?: string, companyId?: string) {
	const enabled = !!organizationId && !!companyId;

	return useQuery(['sectors', { organizationId, companyId }], () => getSectors(organizationId!, companyId!), {
		enabled
	});
}
